import FormTemplate from "./FormTemplate";

export { FormTemplate };